import React, { useContext, useEffect, useRef, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import Pagination from "../Pagination";
import dayjs from "dayjs";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import OSearch from "components/reusable/OSearch";
import apiPath from "utils/apiPath";
import DriverTable from "./ServiceTable";
import { BiReset } from "react-icons/bi";
import CategoryImageModal from "./CategoryImageModal";
import AnimatedComponent from "components/reusable/AnimatedComponent";
import helpers from "utils/helpers";
import { IoMdAdd } from "react-icons/io";
import { Link } from "react-router-dom";

function ServiceManager() {
  const { t } = useTranslation();
  const childRef = useRef();
  const { user, updatePageName } = useContext(AuthContext);
  const [imageShowModal, setImageShowModal] = useState(false);
  const manager =
    user?.permission?.find((e) => e.manager === "service-manager") ?? {};
  const [categories, setCategory] = useState();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [isDelete, setIsDelete] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [isInitialized, setIsInitialized] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [filterData, setFilterData] = useState({
    category: "",
    searchkey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });

  useEffect(() => {
    updatePageName(t("SERVICE_PRICE_MANAGER"));
  }, []);

  const getAllService = async (data) => {
    try {
      const { category, startDate, endDate, searchkey, isFilter } = filterData;

      if (
        (data?.deletePage && categories?.length >= 1) ||
        (isFilter &&
          categories &&
          data?.statusChange &&
          categories?.length >= 1)
      ) {
        setPage(page - 1);
        setIsDelete(true);
        setPaginationObj({ ...paginationObj, page: page - 1 });
      } else {
        setIsDelete(false);
      }

      const payload = {
        page,
        pageSize: pageSize,
        status: category,
        startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: helpers.ternaryCondition(
          searchkey?.includes("+"),
          searchkey?.split("-")?.[1],
          searchkey
        ),
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };

      const path = apiPath.adminServiceList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      if (data?.type == "download") {
        helpers.downloadFile(response?.csvFilePath);
        return;
      }

      setCategory(response);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
    } catch (error) {
      console.error("error in get all list==>>>>", error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  useEffect(() => {
    getAllService({ type: "listing" });
  }, [filterData, page, sort]);

  const handleReset = () => {
    setSearchTerm("");
    setFilterData({
      category: "",
      searchkey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    childRef?.current?.onClose();
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      isReset: false,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  const statusPage = (e) => {
    setPage(1);
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true,
    });
  };
  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchkey: debouncedSearchTerm ? debouncedSearchTerm : "",
        isFilter: debouncedSearchTerm ? true : false,
      });
      setPage(1);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  return (
    <div>
      <div className="bg-[#F9F9F9] dark:bg-LightBlue">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg dark:bg-slate-800">
            {/* filter section */}
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-center mb-2 2xl:mb-0">
                  <div className="relative flex items-center mb-3">
                    <OSearch
                      placeholders={t("SEARCH_BY_NAME_DESCRIPTION")}
                      onChange={(e) => {
                        setSearchTerm(e?.target?.value);
                      }}
                      className="w-[300px] h-[38px] rounded-lg"
                      ref={childRef}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <div className="flex items-center  ml-3 mb-3">
                    <select
                      id=""
                      type="text "
                      name="category"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 dark:border-[#fff] rounded-lg border-[#DFDFDF]  dark:text-[#A5A5A5] dark:border-gray-600"
                      placeholder=" "
                      onChange={(e) => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option defaultValue value="">
                        {t("O_ALL")}
                      </option>
                      <option value="active">{t("O_ACTIVE")}</option>
                      <option value="inactive">{t("O_INACTIVE")}</option>
                    </select>
                  </div>
                  <button
                    title={t("O_RESET")}
                    type="button"
                    onClick={handleReset}
                    className="bg-gradientTo text-sm px-6 flex gap-2 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
                  >
                    <BiReset size={18} /> {t("O_RESET")}
                  </button>
                </div>
              </div>

              {(manager?.add || user?.role === "admin") && (
                <div className="flex justify-end">
                  <Link
                    to={"add"}
                    type="button"
                    title={t("ADD_SERVICE")}
                    className="bg-gradientTo text-sm flex gap-2 px-4 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto"
                  >
                    <IoMdAdd size={18} />
                    {t("ADD_SERVICE")}
                  </Link>
                </div>
              )}
            </form>

            <AnimatedComponent>
              <DriverTable
                country={categories?.docs}
                getAllCategory={getAllService}
                page={page}
                setSort={setSort}
                sort={sort}
                setPage={setPage}
                setSelectedItem={setSelectedItem}
                setCategory={setCategory}
                setImageShowModal={setImageShowModal}
                manager={manager}
              />
            </AnimatedComponent>
            <AnimatedComponent>
              {paginationObj?.totalItems ? (
                <Pagination
                  handlePageClick={handlePageClick}
                  options={paginationObj}
                  isDelete={isDelete}
                  page={page}
                />
              ) : null}
            </AnimatedComponent>
          </div>
        </div>
      </div>

      {imageShowModal && (
        <CategoryImageModal
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          closeImageModal={setImageShowModal}
        />
      )}
    </div>
  );
}

export default ServiceManager;
